import React from "react";

const RightArrow = ({ onClickHandle, isActive }: any) => (
    <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClickHandle}>
    <path d="M11.8009 8.99837L3.65433 17.4844L0.939453 14.6544L6.37113 8.99837L0.939453 3.34237L3.65433 0.512375L11.8009 8.99837Z" fill={isActive ? "#5F67E0":"#C7C7C7"}/>
    </svg>

);

export default RightArrow;